import { render, staticRenderFns } from "./singleAdministrationChildrenFirstEdit.vue?vue&type=template&id=f485aa28"
import script from "./singleAdministrationChildrenFirstEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenFirstEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenFirstEdit.vue?vue&type=style&index=0&id=f485aa28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports